import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { ASSET_TYPES } from "~/consts";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

type AssetTypeValue = (typeof ASSET_TYPES)[keyof typeof ASSET_TYPES];

const ASSET_TYPE_LABELS: Record<AssetTypeValue, string> = {
    Pool: "Pool",
    Loan: "Loan",
    ETF: "ETF",
    ETP: "ETP",
    MUTUAL_FUND: "Mutual Fund",
    EQUITY: "Equity",
} as const satisfies Record<AssetTypeValue, string>;

/**
 * Returns a human-readable label for an asset.type value
 */
const getAssetTypeLabel = (type: string | null): string | null => {
    if (!type) {
        return null;
    }

    return ASSET_TYPE_LABELS[type as AssetTypeValue] ?? type;
};

export const TYPE_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> = {
    slug: AssetColumns.type,
    sortsOn: AssetColumns.type,
    tooltip: CatalogReferenceDataSlugs.type,
    label: "Type",
    type: ColumnTypes.string,
    width: 140,
    cellValue: (item) => {
        if (!item.isAsset) {
            return null;
        }

        return getAssetTypeLabel(item.type);
    },
};

// export const PEGGED_ASSET_TYPE_COLUMN: ColumnMetadata<
//     AssetTableRowData,
//     AssetColumns
// > = {
//     slug: AssetColumns.peggedAssetType,
//     sortsOn: AssetColumns.peggedAssetType,
//     tooltip: CatalogReferenceDataSlugs.type,
//     label: "Pegged Asset Type",
//     type: ColumnTypes.string,
//     width: 160,
//     cellValue: (item) => {
//         if (!item.isAsset) {
//             return null;
//         }

//         return getAssetTypeLabel(item.pegged_asset?.type ?? null);
//     },
// };
